// externals
import type { FC } from 'react';
import { useContext } from 'react';

// libraries
import { DcVppVehicleUsage } from '@makemydeal/dr-platform-types';
import {
    PRINCIPAL_DRIVER_NAME_MAX_LENGTH,
    PRINCIPAL_DRIVER_NAME_TOO_LONG_MESSAGE
} from '@makemydeal/dr-dash-store/utils/contractFieldErrorConfigs';

// components
import { FormContext } from '../formManager/formContext';
import { FormSelectInput } from '../formManager/FormSelectInput';
import { FormTextInput } from '../formManager/FormTextInput';

// interfaces/types
import { FMField } from '../types';

export const primaryUseOptions = [
    { label: 'Personal', value: DcVppVehicleUsage.PERSONAL },
    { label: 'Business', value: DcVppVehicleUsage.BUSINESS },
    { label: 'Agricultural', value: DcVppVehicleUsage.AGRICULTURAL }
];

export const PrimaryUseFields: FC = () => {
    const { form } = useContext(FormContext);
    const isBusinessUse = form.values[FMField.vehicleUse] === DcVppVehicleUsage.BUSINESS;

    return (
        <>
            <FormSelectInput
                label="Primary Use"
                name={FMField.vehicleUse}
                options={primaryUseOptions}
                errorMessage={form.error[FMField.vehicleUse]}
                placeholder="select"
            />
            {/* Reserved cell keeps Location in the left column when the driver name is hidden */}
            {isBusinessUse ? (
                <FormTextInput
                    label="Principal Driver Name"
                    name={FMField.principalDriverName}
                    maxLength={PRINCIPAL_DRIVER_NAME_MAX_LENGTH}
                    maxLengthErrorMessage={PRINCIPAL_DRIVER_NAME_TOO_LONG_MESSAGE}
                />
            ) : (
                <div />
            )}
        </>
    );
};
